export default __webpack_public_path__ + "static/media/CR.9590a2b8.svg";